import React, { useState, useEffect } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { HeaderEditor } from "../selectaAdmin/HeaderEditor";
import { NavigationListMD } from "../../components/navigationList/NavigationMD";
import { ContentPanel } from "../../components/contentPanel/ContentPanel";
import { useAuth } from "../../context/AuthContext";
import { NavigationList } from "../../components/navigationList/NavigationList";
import { useTheme } from "@mui/material/styles";
import { filteredListItems } from "../../components/sharedComponents/PanelList";
import { useFetchDocument } from "../../hooks/useGetDocument";

const EditorLayout = () => {
  const [selectedItem, setSelectedItem] = useState(0);
  const [menuOpen, setMenuOpen] = useState(true);
  const [documentID, setDocumentID] = useState(null);
  const [nameDocument, setNameDocument] = useState("");
  const [modal, setModal] = useState(false);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { token, user, loading } = useAuth();
  const ListItems = filteredListItems(user?.rol);

  const {
    document: documents,
    loading: documentsLoading,
  } = useFetchDocument(token);

  const handleItemClick = (id) => {
    setSelectedItem(id);
  };

  useEffect(() => {
    if (!documentID && selectedItem !== 0 && selectedItem !== 8) {
      setSelectedItem(0);
    }
  }, [documentID, selectedItem]);

  useEffect(() => {
    if (documentID === "1000242") {
      setModal(true);
    }
  }, [documentID]);

  const renderMainContent = () => {
    const sectionsWithoutDocument = [0, 8];
    const needsDocument = !sectionsWithoutDocument.includes(selectedItem);

    if (needsDocument && !documentID) {
      return (
        <ContentPanel
          selectedItem={0}
          token={token}
          idDocument={documentID}
          rol={user?.rol}
          nameDocument={nameDocument}
        />
      );
    }

    return (
      <ContentPanel
        selectedItem={selectedItem}
        token={token}
        idDocument={documentID}
        rol={user?.rol}
        nameDocument={nameDocument}
      />
    );
  };

  const isItemDisabled = (itemId) => {
    const sectionsWithoutDocument = [0, 8];
    return !sectionsWithoutDocument.includes(itemId) && !documentID;
  };

  const navigationProps = {
    menuOpen,
    handleItemClick,
    documentID,
    setDocumentID,
    setNameDocument,
    selectedItem,
    rol: user?.rol,
    isItemDisabled,
  };

  const renderNavigationContent = () => {
    if (loading) {
      return <div>Cargando...</div>;
    }

    if (isMdUp) {
      return (
        <NavigationList
          {...navigationProps}
          ListItems={ListItems}
          documents={documents}
          documentsLoading={documentsLoading}
        />
      );
    }

    return (
      <NavigationListMD
        {...navigationProps}
        handleMenuToggle={() => setMenuOpen(!menuOpen)}
        ListItems={ListItems}
        documents={documents}
        documentsLoading={documentsLoading}
      />
    );
  };

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid
        item
        xs={isMdUp ? (!menuOpen ? 1 : 2) : 0}
        style={
          isMdUp
            ? {
                height: "100%",
                borderRight: "1px solid rgba(127, 127, 127, 0.5)",
                transition: "all 0.3s ease",
              }
            : {}
        }
      >
        {renderNavigationContent()}
      </Grid>

      <Grid
        item
        xs={isMdUp ? (!menuOpen ? 11 : 10) : 12}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          transition: "all 0.3s ease",
        }}
      >
        <div style={{ height: "13%", minHeight: "60px" }}>
          <HeaderEditor
            handleMenuToggle={() => setMenuOpen(!menuOpen)}
            nameDocument={nameDocument}
            userMe={user}
            selectedItem={selectedItem}
            documentID={documentID}
          />
        </div>

        <div style={{ height: "90%", overflow: "hidden" }}>
          {renderMainContent()}
        </div>
      </Grid>

      {modal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        ></div>
      )}
    </Grid>
  );
};

export default EditorLayout;
